import React from "react";

const LANGUAGE_LABELS = {
  javascript: "JavaScript",
  python: "Python",
  java: "Java",
  cpp: "C++",
  go: "Go",
  ruby: "Ruby",
  csharp: "C#",
};

// Plain select. allowedLanguages defaults to the standard 7 if not configured.
// Switching languages warns the candidate before discarding their code.
export default function LanguageSelector({ value, onChange, allowed }) {
  const list = Array.isArray(allowed) && allowed.length > 0
    ? allowed
    : Object.keys(LANGUAGE_LABELS);

  const handleChange = (e) => {
    const next = e.target.value;
    if (next === value) return;
    if (!window.confirm("Switching languages will reset your code. Continue?")) return;
    onChange(next);
  };

  return (
    <select
      value={value}
      onChange={handleChange}
      className="px-2 py-1 rounded bg-slate-800 border border-slate-700 text-slate-200 text-xs"
    >
      {list.map((lang) => (
        <option key={lang} value={lang}>
          {LANGUAGE_LABELS[lang] || lang}
        </option>
      ))}
    </select>
  );
}
